import { Injectable } from "@angular/core";
import { FilterParams, SearchParams, SortOrderType, SortParams } from "./SearchParams";

@Injectable({ providedIn: 'root' })
export class SearchService {

    currentQuery: SearchParams;

    constructor() {
        this.currentQuery = { page: 1, pageSize: 10 };
    }

    resetQuery(pageSize?: number) {
        if (pageSize) {
            this.currentQuery = { page: 1, pageSize: pageSize };
        } else {
            this.currentQuery = { page: 1, pageSize: 10 };
        }
    }

    removeSearchAndSortQueries() {
        this.removeSort();
        this.removeTextQuery();
    }

    setOrganizationId(organization_id: number) {
        this.currentQuery.organizationId = organization_id;
    }

    removeOrganizationId() {
        delete this.currentQuery.organizationId;
    }

    addTextQuery(freeText: string) {
        this.currentQuery.freeText = freeText;
    }

    removeTextQuery() {
        delete this.currentQuery.freeText;
    }

    updateFilter(filter: FilterParams) {
        if (!this.currentQuery.filterParams) {
            this.currentQuery.filterParams = [];
        }


        const shouldCreateFilter = !this.filterExists(filter.fieldName);
        if (shouldCreateFilter) {
            this.currentQuery.filterParams.push(filter);
            return;
        }

        const existingFilter = this.getFilter(filter.fieldName);
        if (existingFilter) {
            filter.value = filter.value.filter((v) => !existingFilter.value.includes(v));
            existingFilter.value = [...existingFilter.value, ...filter.value];
        }
    }

    filterExists(fieldName: string): boolean {
        return this.currentQuery.filterParams?.some(filter => filter.fieldName === fieldName) ?? false;
    }

    getFilter(fieldName: string): FilterParams | undefined {
        return this.currentQuery.filterParams?.find(f => f.fieldName === fieldName);
    }

    removeFilter(fieldName: string) {
        if(!this.currentQuery.filterParams) {
            return;
        }

        this.currentQuery.filterParams = this.currentQuery.filterParams.filter((f) => f.fieldName != fieldName);
    }

    removeValueFromFilter(fieldName: string, value: string) {
        if (!this.currentQuery.filterParams) {
            return;
        } 

        const filter = this.currentQuery.filterParams.find((f) => f.fieldName === fieldName);
        if (filter) {
            filter.value = filter.value.filter((v) => v != value);
        }

        if (filter?.value.length === 0) {
            this.removeFilter(fieldName);
        }
    }

    replaceFilter(filter: FilterParams) {
        this.removeFilter(filter.fieldName);
        this.updateFilter(filter);
    }

    addSort(sort: SortParams) {
        this.currentQuery.sortParams = sort;
    }

    removeSort() {
        delete this.currentQuery.sortParams;
    }

    queryActive(): boolean {
        const hasFilter = this.currentQuery.filterParams != null && this.currentQuery.filterParams.length > 0;
        const hasSort = this.currentQuery.sortParams != null;
        const hasFreeText = this.currentQuery.freeText != null;

        return hasFreeText || hasFilter || hasSort;
    }

    setPage(newPage: number) {
        this.currentQuery.page = newPage;
    }

    setPageSize(newPageSize: number) {
        this.currentQuery.pageSize = newPageSize;
    }

    setSort(field: string, sortOrder: SortOrderType): void {
        this.currentQuery.sortParams = { sortField: field, sortOrder: sortOrder };
    }
}